export enum StatusColor {
  APPROVED = "#28A157",
  FAILED = "#A10D16",
  NOT_EVALUATED = "#D0D0D0",
}
